import Popconfirm from 'antd/lib/popconfirm'

import 'antd/lib/popconfirm/style'

export * from 'antd/lib/popconfirm'

export default Popconfirm
